var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7497 12.9625L17.7497 3.87495C17.381 3.53765 16.8994 3.35059 16.3997 3.35059C15.9 3.35059 15.4184 3.53765 15.0497 3.87495L5.04968 12.9625C4.84494 13.1498 4.68141 13.3776 4.56951 13.6316C4.4576 13.8855 4.39977 14.16 4.39968 14.4375V25.95C4.39155 26.4542 4.56956 26.9437 4.89968 27.325C5.08704 27.538 5.31784 27.7085 5.57657 27.8249C5.8353 27.9413 6.11596 28.001 6.39968 28H12.3997C12.6649 28 12.9193 27.8946 13.1068 27.7071C13.2943 27.5195 13.3997 27.2652 13.3997 27V21C13.3997 20.7347 13.505 20.4804 13.6926 20.2928C13.8801 20.1053 14.1345 20 14.3997 20H18.3997C18.6649 20 18.9193 20.1053 19.1068 20.2928C19.2943 20.4804 19.3997 20.7347 19.3997 21V27C19.3997 27.2652 19.505 27.5195 19.6926 27.7071C19.8801 27.8946 20.1345 28 20.3997 28H26.3997C26.7314 28.0029 27.0584 27.9211 27.3497 27.7625C27.6667 27.5898 27.9314 27.3351 28.1161 27.025C28.3009 26.715 28.3988 26.3609 28.3997 26V14.4375C28.3996 14.16 28.3418 13.8855 28.2299 13.6316C28.1179 13.3776 27.9544 13.1498 27.7497 12.9625V12.9625Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.2d4a65569ea4d16cec784bcb6806cc47.svg";
export { ForwardRef as ReactComponent };